import React from 'react';

// The context will hold the currently open accordion index and a function to change it
const AccordionContext = React.createContext([null, () => {}]);
export default AccordionContext;